export default __webpack_public_path__ + "static/media/icons-scheduling.9d0b2ee0.svg";